import React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Popover from '@mui/material/Popover';
import { useTranslation } from 'react-i18next';
import { NotificationRepeat } from '../../../models/enums/notifications';

const RepeatOptionPopup: React.FC<{
  currentRepeat: NotificationRepeat | null;
  anchorEl: HTMLButtonElement | null;
  onOptionSelect: (option: NotificationRepeat) => void;
  onClose: () => void;
}> = ({ currentRepeat, anchorEl, onOptionSelect, onClose }) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Popover
        id="repeat-option-popover-id"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Stack>
          {Object.values(NotificationRepeat).map((repeat) => (
            <Button
              sx={(theme) => ({
                px: 2,
                justifyContent: 'space-between',
                width: theme.spacing(24),
                color: theme.palette.action.active,
              })}
              onClick={() => onOptionSelect(repeat)}
              key={repeat}
              size="large"
              disabled={currentRepeat === repeat}
            >
              {t('notification-repeat-' + repeat)}
            </Button>
          ))}
        </Stack>
      </Popover>
    </React.Fragment>
  );
};

export default RepeatOptionPopup;
